import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import {
    MapPin, Phone, Bank, IdentificationCard, Link as LinkIcon, WhatsappLogo, Buildings
} from '@phosphor-icons/react';

const INFO = {
    address: 'De Koppele 693, 5632 LT Eindhoven',
    phone: '06-20933773',
    phoneIntl: '+31620933773',
    whatsapp: '31620933773',
    bank: 'NL02 KNAB 0775888222',
    rijschoolNr: '1640X0',
    kvk: '95126244',
    cbrMachtiging: 'https://mijn.cbr.nl',
    cbrGezondheid: 'https://www.cbr.nl/nl/rijden-en-uw-gezondheid/nl/gezondheidsverklaring',
};

function InfoRow({ icon: Icon, label, value, href, testid }) {
    const content = (
        <div className="flex items-start gap-3 group">
            <div className="mt-0.5 p-1.5 rounded-md bg-[#D4A537]/10 border border-[#D4A537]/30 text-[#D4A537] flex-shrink-0">
                <Icon size={16} weight="bold" />
            </div>
            <div className="flex-1 min-w-0">
                <div className="text-[11px] uppercase tracking-wider text-gray-500 font-medium">{label}</div>
                <div className={`text-sm text-white break-words ${href ? 'group-hover:text-[#D4A537] transition-colors' : ''}`}>
                    {value}
                </div>
            </div>
        </div>
    );
    if (href) {
        return (
            <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testid} className="block py-2 px-1 rounded-md hover:bg-[#1A202C]/60 transition-colors">
                {content}
            </a>
        );
    }
    return <div className="py-2 px-1" data-testid={testid}>{content}</div>;
}

export default function RijschoolInfo() {
    return (
        <Card className="bg-[#2D3748] border-[#4A5568]" data-testid="rijschool-info-card">
            <CardHeader className="pb-3">
                <CardTitle className="text-white flex items-center gap-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    <Buildings size={20} className="text-[#D4A537]" weight="fill" />
                    Rijschool Informatie
                </CardTitle>
                <p className="text-xs text-gray-500 -mt-1">Rijschool AutoPilot</p>
            </CardHeader>
            <CardContent className="space-y-0.5">
                <InfoRow
                    icon={MapPin}
                    label="Adres"
                    value={INFO.address}
                    href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(INFO.address)}`}
                    testid="info-address"
                />
                <InfoRow
                    icon={Phone}
                    label="Telefoon"
                    value={INFO.phone}
                    href={`tel:${INFO.phoneIntl}`}
                    testid="info-phone"
                />
                <InfoRow
                    icon={WhatsappLogo}
                    label="WhatsApp"
                    value="Stuur bericht"
                    href={`https://wa.me/${INFO.whatsapp}`}
                    testid="info-whatsapp"
                />
                <InfoRow
                    icon={Bank}
                    label="Bank (IBAN)"
                    value={INFO.bank}
                    testid="info-bank"
                />
                <InfoRow
                    icon={IdentificationCard}
                    label="Rijschoolnummer"
                    value={INFO.rijschoolNr}
                    testid="info-rijschoolnr"
                />
                <InfoRow
                    icon={IdentificationCard}
                    label="KVK-nummer"
                    value={INFO.kvk}
                    testid="info-kvk"
                />

                <div className="pt-3 mt-2 border-t border-[#4A5568]">
                    <div className="text-[11px] uppercase tracking-wider text-gray-500 font-medium mb-2 px-1">
                        CBR Links
                    </div>
                    <InfoRow
                        icon={LinkIcon}
                        label="Machtiging"
                        value="mijn.cbr.nl"
                        href={INFO.cbrMachtiging}
                        testid="info-cbr-machtiging"
                    />
                    <InfoRow
                        icon={LinkIcon}
                        label="Gezondheidsverklaring"
                        value="cbr.nl/gezondheidsverklaring"
                        href={INFO.cbrGezondheid}
                        testid="info-cbr-gezondheid"
                    />
                </div>
            </CardContent>
        </Card>
    );
}
